export const tr = {
    direct: 'Direct'
};
